import axios from "axios";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export default {
    user(url = baseUrl + '/user/') {
        return {
            login: async (username, password) => axios.post(url + 'authenticate/', { username, password }),
        }
    }
}